import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";
import moment from "moment";

import axiosConfig from "../../../utils/axiosConfig";
import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";
import { PodiumTab } from "../PodiumTab";
import { months } from "../../../utils/general";

export default class WidgetPodiums extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadExpert: true,
      isLoadAgency: true,
      caExpert: null,
      perfExpert: null,
      perfRSE: null,
      caAgency: null,
      perfAgency: null,
      perfRSEAgency: null,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    // Get expert data
    axiosConfig("home/data", {
      data: { type: 2 },
    }).then((res) => {
      if (res.data.success && res.data.array_performance) {
        this.setState({
          caExpert: res.data.array_performance.ca,
          perfExpert: res.data.array_performance.globale,
          perfRSE: res.data.array_performance.RSE,
          isLoadExpert: false,
        });
      } else {
        this.setState({ isLoadExpert: false });
      }
    }).catch(() => {
      this.setState({ isLoadExpert: false });
    });

    // Get agency data
    axiosConfig("home/data", {
      data: { type: 1 },
    }).then((res) => {
      if (res.data.success && res.data.array_performance) {
        this.setState({
          caAgency: res.data.array_performance.ca,
          perfAgency: res.data.array_performance.globale,
          perfRSEAgency: res.data.array_performance.RSE,
          isLoadAgency: false,
        });
      } else {
        this.setState({ isLoadAgency: false });
      }
    }).catch(() => {
      this.setState({ isLoadAgency: false });
    });
  }

  render() {
    const date = `${months[moment().format("M") - 1]} ${moment().format(
      "YYYY"
    )}`;
    const isLoad = this.state.isLoadExpert || this.state.isLoadAgency;

    return (
      <WidgetWrapper
        title="Podiums"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {isLoad ? (
          <Loader />
        ) : (
          <PodiumTab
            perfExpert={this.state.perfExpert}
            caExpert={this.state.caExpert}
            perfAgency={this.state.perfAgency}
            caAgency={this.state.caAgency}
            isLoadExpert={false}
            isLoadAgency={false}
            perfRSE={this.state.perfRSE}
            perfRSEAgency={this.state.perfRSEAgency}
            date={date}
            group={this.context.group}
          />
        )}
      </WidgetWrapper>
    );
  }
}
